<template>
  <v-card>
    <v-card-text>
      {{$t('accessWithTokenDesc')}}
    </v-card-text>
  </v-card>
</template>

<script>

// Mixins
import mxLogin from '@/mixins/globals/mx-login'

export default {
  name: 'AccessWithExpert',
  mixins: [mxLogin],

  props: {
    pToken: {
      type: String,
      required: true
    }
  },

  mounted () {
    this.initApp()
  },

  methods: {
    initApp () {
      if (this.pToken !== '' && this.pToken !== null && this.pToken !== undefined) {
        this.tira = this.pToken
        localStorage.setItem('ExpertToken', true)
        this.inicioSesionUsuario(true)
      }
    }
  }

}
</script>


// WEBPACK FOOTER //
// src/views/AccessWithExpert.vue